module.exports = __webpack_public_path__ + "de8175a0fcc989773a2faa993e8bb9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/DSC-Card.png
// module id = 190
// module chunks = 0